<template>
  <div
    v-if="
      datas &&
      ((datas.minDeposit !== 0 && datas.minDeposit !== null) || (datas.maxDeposit !== 0 && datas.maxDeposit !== null))
    "
    class="text"
  >
    *{{
      datas.minDeposit !== 0 && datas.minDeposit !== null
        ? $t('Deposit.min') +
          numberFormatter(datas.minDeposit) +
          unit +
          (datas.maxDeposit !== 0 && datas.maxDeposit !== null ? ',' : '')
        : ''
    }}
    {{
      datas.maxDeposit !== 0 && datas.maxDeposit !== null
        ? $t('Deposit.max') + numberFormatter(datas.maxDeposit) + unit
        : ''
    }}
  </div>
</template>

<script>
import { numberFormatter } from '@/utils/index.js'

export default {
  name: 'DepositLimitDesc',
  props: {
    datas: {
      type: Object,
      default: () => {}
    },
    unit: {
      type: String,
      default: ''
    }
  },
  methods: { numberFormatter }
}
</script>

<style scoped>
.text {
  font-family: theme('fontFamily.pingFang');
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: theme('colors.text.secondary');
}
</style>
